export class TipoDocumento {

	descrizione: string;

	codice: string;

	public static of(codice: string, descrizione: string): TipoDocumento {
		const td: TipoDocumento = new TipoDocumento();
		td.codice = codice;
		td.descrizione = descrizione;
		return td;
	}
}